import { useAuthStore } from '@personic/shared'

// Map sidebar nav hrefs to module feature keys
export const MODULE_KEYS: Record<string, string> = {
  // Employee admin modules
  '/employee/dashboard': 'module_dashboard',
  '/employee/admin': 'module_tenants',
  '/employee/features': 'module_features',
  '/employee/emails': 'module_emails',
  '/employee/attestations': 'module_emp_attestations',
  '/employee/mindmetal/profiles': 'module_profile_browser',
  '/employee/mindmetal': 'module_mindmetal_admin',
  '/employee/dev-tools': 'module_devtools',
  '/employee/health': 'module_health',
  '/employee/system': 'module_system',
  '/employee/support': 'module_support',
  '/employee/consumer': 'module_consumer_admin',
  '/employee/memory': 'module_memory_admin',
  // Tenant product modules (legacy routes — kept until fully removed)
  '/tenant/dashboard': 'module_tenant_dashboard',
  '/tenant/api-keys': 'module_apikeys',
  '/tenant/developers': 'module_developers',
  '/tenant/profiles': 'module_profiles',
  '/tenant/engage': 'module_engage',
  '/tenant/personas': 'module_personas',
  '/tenant/distillation': 'module_distillation',
  '/tenant/team': 'module_team',
  '/tenant/attestations': 'module_attestations',
  '/tenant/calibration': 'module_calibration',
  '/tenant/billing': 'module_billing',
  '/tenant/memory': 'module_memory',
  '/tenant/settings': 'module_settings',
  // New Platform Settings routes
  '/settings/account': 'module_settings',
  '/settings/team': 'module_team',
  '/settings/integrations': 'module_apikeys',
  '/settings/compliance': 'module_attestations',
  '/settings/calibration': 'module_calibration',
  '/settings/governance': 'module_settings',
  '/settings/notifications': 'module_settings',
  // New Engage routes
  '/engage/dashboard': 'module_engage',
  '/engage/personas': 'module_personas',
  '/engage/skills': 'module_engage',
  '/engage/channels': 'module_engage',
  '/engage/intelligence': 'module_engage',
  '/engage/analytics': 'module_engage',
  // New Admin routes
  '/admin/tenants': 'module_tenants',
  '/admin/users': 'module_features',
  '/admin/testing': 'module_devtools',
  '/admin/models': 'module_mindmetal_admin',
  '/admin/analytics': 'module_dashboard',
  '/admin/compliance': 'module_emp_attestations',
  '/admin/ops': 'module_health',
  '/admin/config': 'module_system',
  '/admin/internal': 'module_devtools',
}

export function useModuleAccess() {
  const { user } = useAuthStore()

  const isSuperuser = user?.role === 'superuser'
  const featureOverrides: string[] = user?.feature_overrides || []

  const hasModule = (href: string): boolean => {
    if (isSuperuser) return true
    if (user?.role === 'tenant_admin') return true
    const moduleKey = MODULE_KEYS[href]
    if (!moduleKey) return true // no restriction defined
    return featureOverrides.includes(moduleKey)
  }

  return { hasModule, isSuperuser }
}
